module.exports = __webpack_public_path__ + "static/media/FeedManufacturingSolution.79afacac.svg";